import { render, staticRenderFns } from "./ParticipantsList.vue?vue&type=template&id=2bca4122&scoped=true"
import script from "./ParticipantsList.vue?vue&type=script&lang=js"
export * from "./ParticipantsList.vue?vue&type=script&lang=js"
import style0 from "./ParticipantsList.vue?vue&type=style&index=0&id=2bca4122&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bca4122",
  null
  
)

export default component.exports